import { put } from '../Services/http';
import { catchError } from './Error.action';
import { show as showNotification } from './Notification.action';

export const CARPRICELISTS_LOAD_ERROR = 'CARPRICELISTS_LOAD_ERROR';
export const CARPRICELISTS_RECEIVE = 'CARPRICELISTS_RECEIVE';

export const loadError = error => ({
    type: CARPRICELISTS_LOAD_ERROR,
    payload: {
        error,
    }
});

export const receive = carPriceLists => ({
    type: CARPRICELISTS_RECEIVE,
    configurator: { carPriceLists }
});

export const setCarPriceList = (SelectedPriceListSystemId) => (dispatch, getState) => {
    const activeCarId = getState().facetedSearch.product.id;
    return put(`/api/carpricelists/setcarpricelist`, { SelectedPriceListSystemId, activeCarId })
        .then(response => response.json())
        .then(carPriceLists => dispatch(receive(carPriceLists)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
        ;
}
